exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".clientcode-dialog .top-bar{background-color:#fffbe3!important;color:#000!important}.clientcode-dialog .popup-inner{bottom:50%!important}.clientcode-dialog .error-text{margin:20px!important;font-size:12px!important;color:#666!important;font-weight:700!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/case/client_code_dialog/clientCodeDialog.less
// module id = 1612
// module chunks = 0